var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ isMobile : _vm.is_mobile },attrs:{"id":"app"}},[_c('div',{staticClass:"ware_wrapper"},[_c('WareHeader'),_c('router-view',{key:_vm.$route.fullPath})],1),_c('WareFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }